import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { RoleCheckbox } from "./RoleCheckbox";
import { Input, Typography, Row, Col, Button } from "antd";
import {
  createRole,
  getInitialPermissions,
  getRoleById,
  editRole,
} from "../../api/roles";
import { useQuery, useMutation } from "react-query";
import { AxiosError } from "axios";
import Title from "../UI/Title/Title";
import CancelBtn from "../UI/CancelButton/CancelBtn";

export const CreateEditRole = () => {
  // const navigate = useNavigate();
  const { roleId } = useParams();

  const isEdit = () => {
    return !!roleId;
  };
  const [ids, setIds] = React.useState<number[]>([]);
  const [permissions, setPermissions] = React.useState<Permission[]>();
  const [name, setName] = React.useState<string>("");
  //const [open, setOpen] = React.useState<boolean>(false);
  const { isLoading: editPermissionsLoading, data } = useQuery(
    "roleId",
    () => getRoleById(roleId),
    {
      onSuccess: (data) => {
        setPermissions(data.data.permissions);
        setIds(
          data.data.permissions
            .flatMap((item: any) => item.permissions)
            .filter((permission: permissionList) => permission.isChecked)
            .map((permission: permissionList) => permission.id)
        );
      },
      onError: (error: AxiosError) => {},
      enabled: isEdit(),
    }
  );
  useEffect(() => {
    if (isEdit()) {
      setName(data?.data.value);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.data]);

  const { isLoading: createPermissionsLoading } = useQuery(
    "initialPermissions",
    getInitialPermissions,
    {
      onSuccess: (data) => {
        setPermissions(data.data);
      },
      onError: (error: AxiosError) => {},
      enabled: !isEdit(),
    }
  );
  interface Permission {
    resourceName: string;
    permissions: permissionList[];
  }
  interface permissionList {
    id: number;
    operation: string;
    name: string;
    isChecked: boolean;
  }
  const onSelectedIdsChanged = (
    originalIds: number[],
    selectedIds: number[]
  ) => {
    let replicate = [...ids];
    originalIds.forEach((id) => {
      if (!selectedIds.includes(id)) {
        replicate = replicate.filter((currentId) => currentId !== id);
      } else {
        replicate.push(id);
      }
    });
    replicate = Array.from(new Set(replicate));
    setIds([...replicate]);
  };
  const {  isLoading: isSaving } = useMutation(
    isEdit() ? "editRole" : "createRole",
    isEdit() ? editRole : createRole,
    {
      onSuccess: (data) => {
        //setOpen(true);
      },
      onError: (error: AxiosError) => {},
    }
  );
  // const handleClose = () => {
  //   //setOpen(false);
  //   navigate("/roles", { replace: true });
  // };

  // const HandleCreateUpdate = () => {
  //   if (roleId) {
  //     mutateCreateUpdate({
  //       id: Number(roleId),
  //       name: name,
  //       permissionIds: ids,
  //     });
  //   } else {
  //     mutateCreateUpdate({
  //       name: name,
  //       permissionIds: ids,
  //     });
  //   }
  // };
  return (
    <>
      {editPermissionsLoading || createPermissionsLoading || (
        <>
          <Row>
            <Title title={"Role Information"} />
            <Input
              name="Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
            <Typography>Permissions</Typography>
            <Col>
              {permissions?.map((permission: Permission) => (
                <RoleCheckbox
                  name={permission.resourceName}
                  key={permission.resourceName}
                  permissions={permission.permissions}
                  onSelectedIdsChanged={onSelectedIdsChanged}
                />
              ))}
            </Col>
            <Row>
              <CancelBtn />
              <Button
                disabled={
                  roleId
                    ? false
                    : name.length === 0 || ids.length === 0 || isSaving
                }
                // onClick={HandleCreateUpdate}
              >
                {roleId ? "Save" : "Add"}
              </Button>
            </Row>
          </Row>
        </>
      )}
    </>
  );
};
